import { render, staticRenderFns } from "./setting-accountLabels.vue?vue&type=template&id=616057c4&scoped=true&"
import script from "./setting-accountLabels.vue?vue&type=script&lang=js&"
export * from "./setting-accountLabels.vue?vue&type=script&lang=js&"
import style0 from "./setting-accountLabels.vue?vue&type=style&index=0&id=616057c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616057c4",
  null
  
)

export default component.exports